/**
 * Giải mã chuỗi Unicode mã hóa sai định dạng từ API
 * Xử lý các trường hợp như: "4 tuu1ea7n vu1edbi 1 giu1edd/ngu00e0y"
 * @param text Chuỗi cần giải mã
 * @returns Chuỗi đã giải mã
 */
export const decodeUnicodeString = (text: string): string => {
  if (!text) return '';
  
  // Nếu chuỗi không chứa mã unicode 'u', trả về nguyên bản
  if (!text.includes('u')) return text;
  
  try {
    // Thay thế mã u + 4 ký tự hex thành %u + 4 ký tự
    // Ví dụ: u1ea7 -> %u1ea7
    const withPercentage = text.replace(/u([0-9a-fA-F]{4})/g, '%u$1');
    return decodeURIComponent(withPercentage);
  } catch (error) {
    console.error('Error decoding unicode string:', error);
    return text; // Trả về text gốc nếu có lỗi
  }
};

/**
 * Chuẩn bị chuỗi Unicode trước khi lưu vào database
 * @param text Chuỗi cần chuẩn bị
 * @returns Chuỗi đã được chuẩn bị
 */
export const prepareUnicodeStringForStorage = (text: string): string => {
  if (!text) return '';
  
  // Loại bỏ '%' nếu có
  return text.replace(/%u/g, 'u').replace(/\\u/g, 'u');
}; 